import axios from '../axios/index';

export async function createUser(email, password, username) {
  const url = `/admin/signup`;
  const data = await axios
    .post(url, {
      password: password,
      email: email,
      username: username,
    })
    .then((ree) => ree)
    .catch((err) => err.response);

  if (data?.data?.success) {
    return data?.data;
  } else if (data?.data?.success === false) {
    return data?.data;
  } else {
    return 'error';
  }
}

export async function login(email, password) {
  const url = `/admin/login`;
  const data = await axios
    .post(url, {
      email,
      password,
    })
    .then((ree) => ree)
    .catch((err) => err.response);

  if (data?.data?.success) {
    return data?.data;
  } else if (data?.data?.success === false) {
    return data?.data;
  } else {
    return 'error';
  }
}
